import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const ShiftModelPopup = ({ onSubmit, shiftData }) => {
  const [shiftName, setShiftName] = useState("");
  const [shiftTimeFrom, setShiftTimeFrom] = useState("");
  const [shiftTimeTo, setShiftTimeTo] = useState("");
  const [shiftNameError, setShiftNameError] = useState("");
  const [shiftTimeError, setShiftTimeError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const submitButtonRef = useRef(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (shiftData) {
      setShiftName(shiftData.shift_name);
      setShiftTimeFrom(shiftData.shift_time_from);
      setShiftTimeTo(shiftData.shift_time_to);
      setShiftNameError("");
      setShiftTimeError("");
    } else {
      setShiftName("");
      setShiftTimeFrom("");
      setShiftTimeTo("");
      setShiftNameError("");
      setShiftTimeError("");
    }
  }, [shiftData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!shiftName || !shiftName.trim()) {
      setShiftNameError("Shift Name is required");
      return;
    } else if (shiftName.trim().length > 80) {
      setShiftNameError("Shift Name must not exceed 80 characters");
      return;
    }

    if (!shiftTimeFrom || !shiftTimeTo) {
      setShiftTimeError("Shift Time is required");
      return;
    }

    // Smart validation: Check if shiftTimeFrom is less than shiftTimeTo
    if (shiftTimeFrom >= shiftTimeTo) {
      setShiftTimeError("Start Time must be before End Time");
      return;
    }

    try {
      let response;
      const shiftPayload = {
        shiftName: shiftName,
        startTime: shiftTimeFrom,
        endTime: shiftTimeTo,
        date: new Date().toISOString(),
      };

      if (shiftData) {
        response = await axios.put(
          `${apiUrl}/shifts/update/${shiftData.shift_id}`,
          shiftPayload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Shift updated successfully!");
      } else {
        response = await axios.post(
          `${apiUrl}/shifts/add`,
          shiftPayload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Shift added successfully!");
      }

      const updatedShift = response.data;
      onSubmit(updatedShift);

      if (submitButtonRef.current) {
        submitButtonRef.current.click();
      }

      setShiftName("");
      setShiftTimeFrom("");
      setShiftTimeTo("");
      setShiftNameError("");
      setShiftTimeError("");
    } catch (error) {
      let errorMessage = "Failed to perform the operation. Please try again later.";
      if (error.response && error.response.data && error.response.data.error) {
        errorMessage = error.response.data.error;
      }
      toast.error(errorMessage);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "shiftName") {
      setShiftName(value);
      if (!value.trim()) {
        setShiftNameError("Shift Name is required");
      } else {
        setShiftNameError("");
      }
    } else if (name === "shiftTimeFrom") {
      setShiftTimeFrom(value);
      // Clear shiftTimeError when shiftTimeFrom changes
      setShiftTimeError("");
    } else if (name === "shiftTimeTo") {
      setShiftTimeTo(value);
      // Clear shiftTimeError when shiftTimeTo changes
      setShiftTimeError("");
    }
  };

  return (
    <>
      <div
        id="add_shift"
        className={`modal custom-modal fade ${showModal ? "show" : ""}`}
        role="dialog"
      >
        <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "50%"}} role="document">
        <div className="modal-content h-100">
            <div className="modal-header">
              <h5 className="modal-title">
                {shiftData ? "Edit Shift" : "Add Shift"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <form onSubmit={handleSubmit}>
            <div className="modal-body" style={{ maxHeight: 'calc(100vh - 80px)', overflowY: 'auto' }}>
                <div className="form-group mb-3">
                  <label>Shift Name <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    className={`form-control ${shiftNameError && "is-invalid"}`}
                    value={shiftName}
                    onChange={handleChange}
                    name="shiftName"
                  />
                  {shiftNameError && (
                    <div className="invalid-feedback">{shiftNameError}</div>
                  )}
                </div>
                <div className="form-group mb-3">
                  <label>Start Time</label>
                  <input
                    type="time"
                    className={`form-control ${shiftTimeError && "is-invalid"}`}
                    value={shiftTimeFrom}
                    onChange={handleChange}
                    name="shiftTimeFrom"
                  />
                  {shiftTimeError && (
                    <div className="invalid-feedback">{shiftTimeError}</div>
                  )}
                </div>
                <div className="form-group mb-3">
                  <label>End Time</label>
                  <input
                    type="time"
                    className={`form-control ${shiftTimeError && "is-invalid"}`}
                    value={shiftTimeTo}
                    onChange={handleChange}
                    name="shiftTimeTo"
                  />
                  {shiftTimeError && (
                    <div className="invalid-feedback">{shiftTimeError}</div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  ref={submitButtonRef}
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  {shiftData ? "Save Changes" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShiftModelPopup;
